import { Links } from 'application/constants/links';
import { ProjectProvider } from 'helpers/projectPermissions/ProjectContext';
import { ProjectDetailsPage } from './ProjectDetailsPage';
import { VariablesProvider } from 'pages/authorized/variables/variablesContext/VariablesContext';

export const ProjectDetailsRootPage: React.FC = () => {
  const params = Links.Authorized.ProjectDetails.useParams();

  return (
    <ProjectProvider projectId={params.projectId}>
      <VariablesProvider
        key={`${params.projectId}-${params.queryParams.releaseId}`}
        projectId={params.projectId}
        revisionId={params.queryParams.releaseId ?? undefined}
      >
        <ProjectDetailsPage />
      </VariablesProvider>
    </ProjectProvider>
  );
};
